import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  MessagesState,
  Message,
  CallMessage,
  FeedbackMessage,
} from "../../pages/Communications/utils/types";

const initialState: MessagesState = {
  messages: [],
  averageAiResponseTime: 0,
  averageLeadResponseTime: 0,
  totalCost: 0,
  costCurrency: "",
  channel: "",
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setMessages: (
      state,
      action: PayloadAction<{
        inbox: Message[];
        average_ai_response_time: number;
        average_lead_response_time: number;
        total_cost: number;
        cost_currency: string;
        channel: string;
      }>
    ) => {
      state.messages = action.payload.inbox;
      state.averageAiResponseTime = action.payload.average_ai_response_time;
      state.averageLeadResponseTime = action.payload.average_lead_response_time;
      state.totalCost = action.payload.total_cost;
      state.costCurrency = action.payload.cost_currency;
      state.channel = action.payload.channel;
    },
    clearMessages: (state) => {
      state.messages = [];
      state.averageAiResponseTime = 0;
      state.averageLeadResponseTime = 0;
      state.totalCost = 0;
      state.costCurrency = "";
      state.channel = "";
    },
    appendMessage: (state, action: PayloadAction<Message>) => {
      const alreadyAppended = state.messages.find(
        (msg) => msg?.id === action?.payload?.id
      );
      if (!alreadyAppended) {
        state.messages.push(action.payload);
      }
    },
    replaceMessage: (
      state,
      action: PayloadAction<Message | CallMessage | FeedbackMessage>
    ) => {
      const message = action.payload as Message;
      const index = state.messages.findIndex((msg) => msg.id === message.id);
      if (index !== -1) {
        state.messages[index] = message;
      } else {
        state.messages.push(message);
      }
    },
    updateAverageAiResponseTime: (state, action: PayloadAction<{ averageAiResponseTime: number  }>) => {
      state.averageAiResponseTime = action.payload.averageAiResponseTime;
    },
    updateAverageLeadResponseTime: (state, action: PayloadAction<{ averageLeadResponseTime: number  }>) => {
      state.averageLeadResponseTime = action.payload.averageLeadResponseTime;
    },
  },
});

export const { setMessages, clearMessages, replaceMessage, appendMessage, updateAverageAiResponseTime, updateAverageLeadResponseTime } =
  messagesSlice.actions;
export default messagesSlice;
